import React, { useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { statusColors } from '../../utils/utils';
import { BulletStatusProps } from './types';
import { Styled } from './bullet-status.styled';

const BulletStatus = ({
    label,
    color,
    type,
    icon,
}: BulletStatusProps): JSX.Element => {
    const theme = useTheme();

    const [colors, updateColors] = useState({
        color: theme.palette.success.main,
        background: '',
    });

    useEffect(() => {
        if (!color && type) {
            updateColors(statusColors[type]);
            return;
        }

        if (color) {
            updateColors({
                color: color,
                background: color,
            });
        }
    }, [color, type]);

    return (
        <Styled.Bullet sx={{ backgroundColor: colors.background }}>
            <Box sx={{ background: colors.color }} component="span"></Box>
            <Styled.Label color={colors.color} variant="body2">
                {label && label}
            </Styled.Label>
            {icon && (
                <i
                    className={icon}
                    style={{
                        marginInlineStart: '5px',
                        color:
                            color ??
                            (type ? statusColors[type]?.color : undefined),
                    }}
                />
            )}
        </Styled.Bullet>
    );
};

export { BulletStatus };
